import {rootState} from '@mintdata-wsp/common/state/RootState';
import {observer} from 'mobx-react';
import React from 'react';
import * as classnames from 'classnames/bind';
import {Combo, SourceAnchor, PopupAnchor} from '@mintdata-wsp/common/components/combo/Combo';
import {ListModel, IListItemState} from '@mintdata-wsp/mint-kit/api/models/List';
import {PopupSize} from '@mintdata-wsp/mint-kit/impl/components/popover/PopupTypes';
import {IStyles} from '@mintdata-wsp/mint-kit/impl/util/Styles';
import {ActiveUserEvent} from '@mintdata-wsp/wsp/controllers/multiplayer/MultiplayerController';
import {UserIconPopupCard} from '@mintdata-wsp/wsp/ui/views/visualDesigner/header/userPresence/UserIconPopupCard';
import {action} from 'mobx';

const styles = require('./ActiveUserDots.less');
const cx = classnames.bind(styles);

interface ActiveUserDotsProps
{
    filterPageId?:string;
    filterSheetId?:string;
}

@observer
export class ActiveUserDots extends React.Component<ActiveUserDotsProps>
{
    public render():JSX.Element
    {
        const {filterPageId, filterSheetId} = this.props;
        const {activeUsers} = rootState.ui.visualDesigner;

        const users = activeUsers.otherUsers
            .filter(user => user.userId !== rootState.userSession.currentUser.id)
            .filter(user => !filterPageId || user.page === filterPageId)
            .filter(user => !filterSheetId || user.sheet === filterSheetId);

        // mobx hack to trigger re-render when needed
        activeUsers.otherUsersDetails.size;

        if( !users.length )
            return null;

        const listModel = new ListModel(users);
        listModel.selectFirstItem();

        return <div onClick={(e) => e.stopPropagation()}>
            <Combo key={'combo'}
                className={cx('combo')}
                theme={{
                    content: cx('comboContent', this._getArrowClass()),
                    listView: cx('comboListView')
                }}
                dataSource={listModel}
                contentRenderer={() => this._renderUserDots(users)}
                itemRenderer={this._renderUserIconPopupCards}
                onSelectItem={(user:ActiveUserEvent) => this._handleUserIconClick(user.userId)}
                sourceAnchor={this._getSourceAnchorPosition()}
                popoverAnchor={this._getPopoverAnchorPosition()}
                popupSize={PopupSize.Original}
            >
                <header>
                    <div className={cx('userIconListHeader')}>{`${users.length} user${users.length === 1 ? '' : 's'}`}</div>
                </header>
            </Combo>
        </div>
    }

    private _getSourceAnchorPosition = () => this.props.filterPageId ? SourceAnchor.RightTop : SourceAnchor.LeftTop;

    private _getPopoverAnchorPosition = () => this.props.filterPageId ? PopupAnchor.LeftTop : PopupAnchor.LeftBottom;

    private _getArrowClass = () => this.props.filterPageId ? cx('pages') : cx('sheets');

    private _renderUserDots(users: ActiveUserEvent[]) {
        const {activeUsers} = rootState.ui.visualDesigner;

        return <div className={cx('activeUsersContainer')}>
            {
                users.map(user =>
                {
                    const userDetails = activeUsers.otherUsersDetails.get(user.userId);
                    
                    if( !userDetails )
                        return null;

                    return <div key={user.userId}
                        className={cx('activeUserDot')}
                        title={userDetails.fullName}
                        style={{backgroundColor:userDetails.color}}
                    />
                })
            }
        </div>
    }

    _renderUserIconPopupCards(data:ActiveUserEvent, state:IListItemState, styles:IStyles):JSX.Element
    {
        return <UserIconPopupCard key={data.userId} user={data} />;
    }

    @action
    _handleUserIconClick(userId:number)
    {
        // TODO: Follow Me mode ?
    }
}